import Axios from 'axios';
import responseHandler from 'common/service/utils/responseHandler';
import errorHandler from 'common/service/utils/errorHandler';

export const DccAxiosInstance = Axios.create({
  baseURL: '/dcc-server',
  timeout: 10 * 60 * 1000, // 10min
});
DccAxiosInstance.interceptors.response.use(responseHandler, errorHandler);
